/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDragHorz = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M19.626 13c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m-9 2c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2m-7 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2m4-6c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m3 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2m7 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2" /></svg>;
export default SvgDragHorz;